import { Component, OnDestroy, OnInit } from '@angular/core';
import { 
  CellClickEvent, 
  DataStateChangeEvent, 
  PageChangeEvent, 
  PagerSettings ,
  SelectableSettings,
} from "@progress/kendo-angular-grid";

import { DataResult, State,process, SortDescriptor } from '@progress/kendo-data-query';
import { FinancesService } from 'localServices/finances.service';
import { Family, IntUserPerimeters_XRP, IntUsersService, IntUserStatut, PafListsService, Profil, PS_Lst_IntUsers_Result, PS_PAFX_DR_Result, PS_PV2_AGENCES_Parameters,  SharedDataService } from 'ngx-paf-common';
import { forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { IntUserDetailComponent } from 'src/app/COMPOSANTS/int-user-detail/int-user-detail.component';

@Component({
  selector: 'lst-int-users',
  templateUrl: './lst-int-users.component.html',
  styleUrls: ['./lst-int-users.component.scss']
})
export class LstIntUsersComponent implements OnInit, OnDestroy {

  intUserDetail : IntUserDetailComponent;
  
  constructor(
    public sharedDataSvc: SharedDataService,
    private financesSvc: FinancesService,
    private intUsersSvc: IntUsersService,
    private pafLists: PafListsService,) { }


    private _subs:Subscription[]=[];

  ngOnInit(): void {
    if (!this.sharedDataSvc.allListsLoaded) {
      this._subs.push(this.sharedDataSvc.allListsLoadedChange
        .subscribe(() => {;
          this.loadFixedLists().then(() => {
            this.reload();
          });
        }));
    } else {
      this.loadFixedLists().then(() => {
        this.reload();
      });
    }
  }

  ngOnDestroy(): void {
    this._subs.forEach(s=>s.unsubscribe()); 
  }

  get lstStatuts():IntUserStatut[] {
    return this.sharedDataSvc.lstIntUserStatut;
  }
  get lstProfils():Profil[]{
    return this.sharedDataSvc.lstProfils;
  }
  get lstFamilies():Family[]{
    return this.sharedDataSvc.families;
  }
  get lstSegments():Family[]{
    return this.lstFamilies.filter(f=>(f.FamilyCod||'')=='' && f.Cod2 !='99');
  }

  lstPerimeters:IntUserPerimeters_XRP[]=[];
  lstEtbsXRP: PS_PAFX_DR_Result[] = [];
  lstIntUsers:PS_Lst_IntUsers_Result[]=[];

  

  loadFixedLists(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.financesSvc.Drs(true)
        .subscribe({
          next: results => {
            this.lstEtbsXRP = results;
            resolve && resolve();
          },
          error: reject
        });
    });
  }


  popupSettings:any = {
    width: 800,
    height:630,
    top:100,
    left:undefined,
    windowState : 'default'//'minimized' | 'maximized' | 'default';
  }

  showWindowSubject:Subject<any> = new Subject<any>();
  public gridDatas: DataResult;
  

  public state: State = {
    skip: 0,
    take: 100,  
    sort:  [{
      field: "Lastname",
      dir: "asc",
    }]
    //group:  [{ field: "ProfilLib" }]
  };
  public pagerSettings:PagerSettings = {
    position: 'top',
    pageSizes: [20,50,100],
    previousNext: true,
    responsive: true,
    type:'numeric'
  }
  
  public selectableSettings: SelectableSettings = {
    checkboxOnly:false,
    mode: 'single',
    drag: false,
  }

  
  public get isAdmin(): boolean {
    return this.sharedDataSvc.isAdmin;
  }

  


  reload(): void {
    this.sharedDataSvc.WindowLock();
    this._subs.push(forkJoin([
      this.intUsersSvc.PS_Lst_IntUsers(),
      this.pafLists.getIntUserPerimeters(),
    ])
      .subscribe(results => {
        this.lstIntUsers = results[0];
        this.lstPerimeters = results[1];
        this.lstIntUsers.forEach(user => {
          (<any>user).referent = this.lstIntUsers.find(t => t.Id == user.AchRefId && t.Id != user.Id) || {}; //ne pas affecter soi-meme comme referent sinon boucle infinie
          const perimeters: IntUserPerimeters_XRP[] = this.lstPerimeters
            .filter(perimeter => perimeter.IntUserId == user.Id && (user.SapPerimeterIds || '')
              .split('|').some(id => id == perimeter.Id.toString()));
          const socs: string[] = perimeters.map((p: IntUserPerimeters_XRP) => p.Soc_XRP).distinct();
          (<any>user).perimeters = perimeters;
          (<any>user).socsSAP = socs.join(';');
          let etbs: PS_PAFX_DR_Result[] = this.lstEtbsXRP
            .filter(e => (socs.indexOf(e.SocCod) >= 0 || socs.indexOf('*') >= 0));

          if (perimeters.some(p => (p.Etb_XRP || '') != '')) {
            if (perimeters.some(p => p.Etb_XRP == '*')) {
              (<any>user).etbsSAP = '*';
            } else {
              (<any>user).etbsSAP = perimeters.map(p => p.Etb_XRP).distinct().join(';');
            }
          } else {
            (<any>user).etbsSAP = '';
          }
          let segmentsCods: string[] = this.lstFamilies.filter((family: Family) => (user.FamilyIds || '').split('|').some(id => id == family.Id.toString() && (!family.FamilyCod)))
            .map((segment: Family) => segment.Cod.substring(0, 2)).distinct();
          segmentsCods.sort();
          (<any>user).segments = segmentsCods.join(';');
          if (user.StatutId == 1) {
            (<any>user).datMaj = user.StatutDatMaj;
          } else {
            (<any>user).datSusp = user.StatutDatMaj;
            (<any>user).motifSusp = user.StatutComments;
          }
        });
        this.refreshDataGrid();

        this.sharedDataSvc.WindowUnlock();
      }));
  }

  
  pageChange({ skip, take }: PageChangeEvent): void {
    this.state.skip = skip;
    this.state.take = take;
    this.refreshDataGrid();
  }
  refreshDataGrid():void{
        this.gridDatas = process(this.lstIntUsers,  this.state);
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    state.group = this.state.group;
    this.state = state;
    this.refreshDataGrid();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.state.sort = sort;
    this.refreshDataGrid();
  }
  public ajouter():void{
    this.showWindowSubject.next({intUserId:0, readOnly:false});
  }


  selectedRow: PS_Lst_IntUsers_Result = null;

  public selectRow(event: CellClickEvent): void {
    this.selectedRow = event.dataItem;
  }

  dblClickGridEvent(): void {
    if (!this.selectedRow) return;
    this.view(this.selectedRow);
  }

  onWindowClosed(events:any):void{   
    if (events?.reload) {
      this.reload();
    }
  }

  view(user:PS_Lst_IntUsers_Result):void{
    this.selectedRow = user;
    this.showWindowSubject.next({intUserId:user.Id, readOnly:true});
  }

  edit(user:PS_Lst_IntUsers_Result):void{
    this.selectedRow = user;
    this.showWindowSubject.next({intUserId:user.Id, readOnly:false});
  }

  lock(user:PS_Lst_IntUsers_Result):void{
    if (user?.Id==this.sharedDataSvc?.loggedIntUser?.Id) {
      this.sharedDataSvc.pafAlert('Msg_Auto_Suppression_Admin_Interdite');
      return;
    }

    this.sharedDataSvc.prompt('Veuillez-saisir un motif de blocage de l\'utilisateur',
    (inputValue:string)=>{
      this._subs.push(this.intUsersSvc.changeStatut(user.Id,this.lstStatuts.find(s=>s.Cod=='BLOQUE').Id, inputValue)
      .subscribe(res=>this.reload()));
    });
  }

  unlock(user:PS_Lst_IntUsers_Result):void{
    this._subs.push(this.intUsersSvc.changeStatut(user.Id,this.lstStatuts.find(s=>s.Cod=='ACTIF').Id, '')
      .subscribe(res=>this.reload()));
  }
}

